import { useMemo } from "react"
import { useQuery } from "urql"
import { graphql } from "@/graphql"

const TenantShopSettingsQuery = graphql(`
  query TenantShopSettings {
    tenant {
      restaurant {
        id
        contractPlan
        operatingCompanyName
        contactName
        contactPhoneNumber
        contactEmail
        shop {
          id
          name
          postalCode
          prefecture
          city
          streetAddress
          buildingName
          phoneNumber
          email
        }
      }
    }
  }
`)

export const useTenantShop = () => {
  const [{ data, fetching, error }] = useQuery({
    query: TenantShopSettingsQuery,
  })

  const shopSettings = useMemo(() => {
    const restaurant = data?.tenant?.restaurant
    if (!restaurant) {
      return null
    }

    return {
      restaurantId: restaurant.id,
      shopId: restaurant.shop.id,
      contractPlan: restaurant.contractPlan,
      shopName: restaurant.shop.name,
      postalCode: restaurant.shop.postalCode,
      prefecture: restaurant.shop.prefecture,
      city: restaurant.shop.city,
      streetAddress: restaurant.shop.streetAddress,
      buildingName: restaurant.shop.buildingName ?? "",
      shopPhoneNumber: restaurant.shop.phoneNumber,
      shopEmail: restaurant.shop.email,
      operatingCompanyName: restaurant.operatingCompanyName,
      contactName: restaurant.contactName,
      contactPhoneNumber: restaurant.contactPhoneNumber,
      contactEmail: restaurant.contactEmail,
    }
  }, [data])

  return { shopSettings, fetching, error }
}
